import { ClassNameComponent } from '@/utils/ClassNameComponent';
import Popup from '../Popup';
import MainButton from '../buttons/MainButton';
import { IconWithText } from '../dataDisplay/IconWithText';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { twMerge } from 'tailwind-merge';
import { Placement } from '@popperjs/core';

export type OutlineSelectOption<T> = {
  label: string;
  value: T;
  hide?: boolean;
};

type OutlinedSelectProps<T> = {
  options: OutlineSelectOption<T>[];
  onSelectValue?(value: T): void;
  selectedValue?: T;
  className?: Pick<ClassNameComponent, 'ul' | 'base' | 'text'>;
  offset?: [number, number];
  placement?: Placement;
  hover?: boolean;
};

export default function OutlinedSelect<T>({
  options,
  onSelectValue,
  selectedValue,
  className,
  offset = [-2, -2],
  placement = 'bottom-end',
  hover,
}: OutlinedSelectProps<T>) {
  const selectedOption = options.find(({ value }) => value === selectedValue);
  const filterOptions = ({ hide = false }: OutlineSelectOption<T>) => !hide;

  return (
    <Popup
      placement={placement}
      offset={offset}
      reference={
        <IconWithText
          icon={<ChevronDownIcon className="w-3" />}
          className={{
            base: 'gap-0.5 text-base-content/70 cursor-pointer flex-row-reverse',
            text: twMerge('text-12 font-400 opacity-50', className?.text),
          }}
          text={selectedOption?.label ?? ''}
        />
      }
      hover={hover}
    >
      <ul className="flex flex-col gap-3 border border-neutral-content bg-base-100 p-4 rounded-lg">
        {options.filter(filterOptions).map(({ label, value }) => (
          <li key={label}>
            <MainButton
              className="text"
              color="custom"
              onClick={() => onSelectValue?.(value)}
              text={label}
            />
          </li>
        ))}
      </ul>
    </Popup>
  );
}
